import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { HeaderComponent } from "../components/header/header.component";
import { SidebarComponent } from "../components/sidebar/sidebar.component";
import { SubheaderComponent } from "../components/subheader/subheader.component";
import { DropdownModule } from "primeng/dropdown";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { CalendarModule } from "primeng/calendar";
import { ButtonModule } from "primeng/button";
import { InputNumberModule } from "primeng/inputnumber";

@Component({
  selector: 'app-verify-identity',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DropdownModule,
    InputTextModule,
    InputTextareaModule,
    CalendarModule,
    InputNumberModule,
    ButtonModule,
    SidebarComponent,
    HeaderComponent,
    SubheaderComponent
  ],
  templateUrl: './verify-identity.component.html',
  styleUrl: './verify-identity.component.css'
})
export class VerifyIdentityComponent {
  constructor(private router: Router) {}

  goBack(): void {
    this.router.navigate(['/additional-data']);
  }

  onConfirm(): void {
    this.router.navigate(['/verification-module']);
  }
}
